/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForVmwareVcdMaster extends models.ServiceAccountCredentialsBaseForVmwareVcd {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForVmwareVcdMaster");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForVmwareVcdMaster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForVmwareVcdMaster>): ServiceAccountCredentialsForVmwareVcdMaster {
        let obj = Object.assign(new ServiceAccountCredentialsForVmwareVcdMaster(), model);
        ServiceAccountCredentialsForVmwareVcdMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForVmwareVcdMaster>): ServiceAccountCredentialsForVmwareVcdMaster {
        if (!model) return null;
        return ServiceAccountCredentialsForVmwareVcdMaster.newInstance(<ServiceAccountCredentialsForVmwareVcdMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForVmwareVcdMaster) {
        if (!obj) return;

        models.ServiceAccountCredentialsForVmwareVcdMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForVmwareVcdMaster): boolean {
        if (models.ServiceAccountCredentialsBaseForVmwareVcd.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForVmwareVcdMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
